import styled, { css } from 'styled-components';

export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 0;
`;

export const CarouselNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  padding: 0;
`;

export const CarouselNavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;

export const CarouselDots = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
`;

export const CarouselDot = styled.button`
  ${({ theme, isActive }) => css`
    width: 10px;
    height: 10px;
    border-radius: 30px;
    border: none;
    padding: 0;
    cursor: pointer;
    background-color: ${isActive ? theme.v3.colors.brand.snappyBlue[60] : theme.v3.colors.neutral[90]};
    transition: background-color 0.2s;
  `}
`;

export const PlanListViewport = styled.div`
  ${({ showFade }) => css`
    overflow: hidden;
    width: 100%;

    ${showFade ? css`
      mask-image: linear-gradient(to right, black 0%, black 90%, transparent 100%);
      -webkit-mask-image: linear-gradient(to right, black 0%, black 90%, transparent 100%);
    ` : css`
      mask-image: none;
      -webkit-mask-image: none;
    `}
  `}
`;

export const PlanListWrapper = styled.div`
  ${({ index, visibleCards }) => {
    const n = visibleCards || 3;
    const gaps = (n - 1) * 16;
    return css`
      display: flex;
      flex-direction: row;
      gap: 16px;
      align-items: stretch;
      height: 100%;
      transform: translateX(calc(${-(index || 0)} * (var(--carousel-vw, 100%) + 16px) / ${n}));
      transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);

      & > * {
        flex: 0 0 calc((var(--carousel-vw, 100%) - ${gaps}px) / ${n});
        min-width: 0;
      }
    `;
  }}
`;
